import { render } from "./order.vue?vue&type=template&id=bf40b156&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"

import "./order.vue?vue&type=style&index=0&id=bf40b156&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-bf40b156"

export default script